import React from 'react'

const TableSkeleton = ({ rows = 6, columns }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          <td colSpan={columns} className="px-4 py-3">
            <div className="flex gap-4">
              {Array.from({ length: columns }).map((_, colIndex) => (
                <div
                  key={colIndex}
                  className="h-4 flex-1 rounded bg-gray-200 dark:bg-gray-700 animate-pulse"
                />
              ))}
            </div>
          </td>
        </tr>
      ))}
    </>
  )
}

export default TableSkeleton
